import React                   from 'react'
import i18n from '../../../i18n';

export default (props) => {
  return (
    <div className="row no-gutters">
      <div className="col-sm-12 title">
        <div className="float-left">{i18n.t("application.application_list")}</div>
      </div>
    </div>
  )
}